import * as React from 'react'

import { LoanOfferListItem } from 'embed/constants'
import { SpecialOffer } from 'embed/constants/models'
import { SortDirection, SpecialOfferSortOption } from 'even-ts-static'
const styles = require('embed/styles/results')

export interface Props {
  bestOfferId?: string
  dispatchSpecialOfferCta?: (offer: SpecialOffer) => void
  isResultsView?: boolean
  listItem?: LoanOfferListItem<SpecialOffer>
  onSortOptionClick: (sortOption: SpecialOfferSortOption) => void
  sort?: SpecialOfferSortOption
  sortDirection?: SortDirection
  specialOffers: SpecialOffer[]
}

const SpecialOfferList: React.SFC<Props> = ({
  listItem: ListItem,
  bestOfferId,
  dispatchSpecialOfferCta,
  isResultsView,
  specialOffers,
}) =>
  ListItem !== undefined && specialOffers.length ? (
    <div>
      <ol className={styles.list}>
        {specialOffers.map((offer) => (
          <ListItem
            bestOfferId={bestOfferId}
            dispatchOfferCta={dispatchSpecialOfferCta}
            isResultsView={isResultsView}
            key={offer.uuid}
            offer={offer}
            shouldDisplayTransunionDisclaimer={false}
          />
        ))}
      </ol>
    </div>
  ) : null

export default SpecialOfferList
